// this fires based on url params, not directly off form submission, which triggers a page refresh
$(document).ready(function () {
  try {
    if (window.location.pathname === '/') {
      // check correct search param is present
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('form_type') !== 'customer') return;

      // check message hasn't been displayed before
      let newsletterSessionStore = sessionStorage.getItem('customerNewsletter');
      if (newsletterSessionStore) return;

      const user = {};
      for (let [key, value] of urlParams) {
        user[key] = value;
      }

      if (Object.keys(user).length === 0) return;
      const email = user['contact[email]'] || '';
      const firstName = user['contact[first_name]'] || '';
      const lastName = user['contact[last_name]'] || '';

      const displayName = firstName ? `${firstName} ${lastName}` : email;
      // display modal message
      const elem = displayFormSubmitModal(displayName);
      setTimeout(() => hideModal(elem), 6000);
      // add to sessionStorage to prevent recurrence
      sessionStorage.setItem('customerNewsletter', 'true');
    }
  } catch (e) {
    Rollbar.error('newsletter form success', e);
  }
  // only run on homepage
});

function displayFormSubmitModal(displayName) {
  const elem = document.querySelector('.form-success-modal');
  elem.querySelector('.customer-text').textContent = `Hey ${displayName}!`;
  elem.style.display = 'flex';
  return elem;
}

function hideModal(elem) {
  elem.querySelector('.customer-text').textContent = '';
  elem.style.display = 'none';
}
